<main>
    <div class="gradient"></div>
    <app-trends-header-component></app-trends-header-component>
    <app-trends-intro-component></app-trends-intro-component>
    <app-sections-component></app-sections-component>
    <app-references-section></app-references-section>
    <app-footer></app-footer>
</main>
